import HBox from '../../layout/container/h_box/HBox';
import PuzzleButton from '../../UI/button/PuzzleButton';
import React from 'react';
import { Position } from '../../../dispatcher/Types';
import { Component } from '../../../index';
import * as _ from 'lodash';
import { BASE_DRAWER_PROPS, BASE_DRAWER_STATE } from './Types';

class BaseDrawer extends Component<BASE_DRAWER_PROPS, BASE_DRAWER_STATE> {
  /**
     * Triggers edit action if one is configured
     */
  onEdit = () => {
    this.dispatch(this.props.editAction, Position.end, {
      dataItem: this.props.drawerData
    });
  };

  /**
     * Triggers drawer close action
     */
  onClose = () => {
    if (_.isFunction(this.props.onDrawerToggle)) {
      this.props.onDrawerToggle(false);
    }
    this.dispatch('CloseDashboardDrawer', Position.end);
  };

  render() {
    const { className, title, editAction, drawerData, children } = this.props;
    return (
      <div
        className={`tp-page ${className}`}
        data-preventrecorddeselect={'true'}
      >
        <div className={'tp-page-drawer'}>
          <HBox
            alignItemsCenter
            justifyContentBetween
            className={'tp-page-drawer-header'}
          >
            <div
              data-cy={'drawer-title'}
              className={'tp-page-drawer-title'}
            >{title}</div>
            <HBox className={'tp-page-drawer-actions'}>
              {editAction && <PuzzleButton
                size={'small'}
                fillMode={'flat'}
                aria-label={this.translate('ariaEditLabel')}
                title={this.translate('editButtonText')}
                className={'tp-page-drawer-edit-button'}
                iconClass={'tp-icon tp-edit'}
                onClick={this.onEdit}
              />}
              <PuzzleButton
                size={'small'}
                data-cy={'closeDefaultDrawer'}
                fillMode={'flat'}
                aria-label={this.translate('ariaCloseLabel')}
                title={this.translate('closeButtonText')}
                className={'tp-page-drawer-close-button'}
                iconClass={'tp-icon tp-close'}
                onClick={this.onClose}
              />
            </HBox>
          </HBox>
          <div className={'tp-page-drawer-body'}>
            {
              React.Children.map(children, function (child) {
                // @ts-ignore
                return React.cloneElement(child, {
                  data: drawerData
                });
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

export default BaseDrawer;
